<template>
	<div data-tour-scope="setting-vat">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.vat') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-btn depressed color="primary" data-tour="add" @click="dialogNuova = true"><v-icon left>mdi-plus</v-icon>Nuova aliquota</v-btn>
						</v-toolbar>

						<!-- telefono: ogni aliquota diventa una card chiave/valore -->
						<div v-if="mobileCards" class="kv-list pa-3" data-tour="table">
							<div v-if="!vats || vats.length === 0" class="grey--text text-center py-4">Nessuna aliquota</div>
							<key-value-card v-for="(item, index) of vats" :key="item._id || index" :title="item.vat + ' %'">
								<template v-slot:actions>
									<v-chip v-if="item.default" x-small outlined color="primary" class="mr-1">Predefinita</v-chip>
									<v-menu v-else left eager>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === primaNonDefault ? 'row-menu' : null">
												<v-icon>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item link @click="changeDefault(item)">
												<v-list-item-title class="size9">Rendi predefinita</v-list-item-title>
											</v-list-item>
											<v-list-item link @click="deleteItem(item)">
												<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</template>
								<div class="d-flex align-center justify-space-between">
									<span class="card-label">Status</span>
									<v-switch v-model="item.is_active" @change="changeStatus" color="primary" class="mt-0 pt-0" hide-details></v-switch>
								</div>
							</key-value-card>
						</div>
						<v-simple-table v-else data-tour="table">
							<template v-slot:default>
								<thead>
									<tr>
										<th style="width: 40px"></th>
										<th class="text-left">Aliquota</th>
										<th class="text-left">Status</th>
										<th class="text-left">Default</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="!vats || vats.length === 0">
										<td colspan="4" class="grey--text text-center">Nessuna aliquota: aggiungila con "Nuova aliquota"</td>
									</tr>
									<tr v-for="(item, index) of vats" :key="item._id || index">
										<td class="pl-0 pr-0" style="width: 40px">
											<v-menu v-if="!item.default" right eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === primaNonDefault ? 'row-menu' : null">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="changeDefault(item)">
														<v-list-item-title class="size9">Rendi predefinita</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td class="font-weight-medium">{{ item.vat }} %</td>
										<td>
											<v-switch v-model="item.is_active" @change="changeStatus" color="primary" class="mt-0" hide-details></v-switch>
										</td>
										<td>
											<v-chip v-if="item.default" small outlined color="primary">Predefinita</v-chip>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>

		<VatDialog v-model="dialogNuova" :esistenti="vats.map(v => v.vat)" @add="addValue" />

		<v-dialog v-model="dialogconfirm" max-width="360">
			<v-card>
				<v-card-title class="headline">Eliminare l'aliquota {{ daEliminare ? daEliminare.vat : '' }}%?</v-card-title>
				<v-card-text>Sparisce dall'elenco delle aliquote proponibili sui prodotti.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import VatDialog from './components/VatDialog.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createVatTourSteps } from './vat-tour';
/*import SocketIO from 'socket.io-client'
    var socket= SocketIO({
        debug: true,
        connection: 'http://127.0.0.1:4000'
    })*/

//var socket = io('127.0.0.1:4000')
//console.log(socket)
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
//import moment from 'vue-moment';

export default {
	name: 'Vat',
	setup() {
		return { tour: useTour(createVatTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					payments: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			dialogNuova: false,
			// aliquota in attesa di conferma nel dialog di eliminazione
			daEliminare: null,
			// filters: {
			//     Status: [],
			//     Platform: [],
			//     created_at: [],
			// },
			/* pagination:{
                     sortBy: 'buyer.name',
                     descending: true,
                     rowsPerPage: 15
                 },*/
			//options: {},
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: 'Lingua', value: '' },
				{ text: 'Status', value: '' },
				{ text: 'Default', value: '' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			form: {
				vat: '',
				is_active: false,
			},

			isMobile: false,
			it: {
				is_active: '',
				default: '',
				type: 'it',
			},
			en: {
				is_active: '',
				default: '',
				type: 'en',
			},
			de: {
				is_active: '',
				default: '',
				type: 'de',
			},
			fr: {
				is_active: '',
				default: '',
				type: 'fr',
			},
			es: {
				is_active: '',
				default: '',
				type: 'es',
			},
			vats: [],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},
	/* sockets: {
            connect() {
                console.log('socket connected')
            },
            customEmit(val) {
                console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
            }
        },*/

	async created() {
		this.setPreload(true);
		await this.fetchSettings();

		//console.log(result)
		this.vats = this.getSettings.vat || [];
		//this.items = result.data.data
		this.setPreload(false);

		var it = _.find(this.getSettings.languages, set => {
			return set.lang == 'it';
		});
		if (it) {
			this.it.is_active = it.is_active;
			this.it.default = it.default;
		}
		var en = _.find(this.getSettings.languages, set => {
			return set.lang == 'en';
		});
		if (en) {
			this.en.is_active = en.is_active;
			this.en.default = en.default;
		}
		var de = _.find(this.getSettings.languages, set => {
			return set.lang == 'de';
		});
		if (de) {
			this.de.is_active = de.is_active;
			this.de.default = de.default;
		}
		var fr = _.find(this.getSettings.languages, set => {
			return set.lang == 'fr';
		});
		if (fr) {
			this.fr.is_active = fr.is_active;
			this.fr.default = fr.default;
		}
		var es = _.find(this.getSettings.languages, set => {
			return set.lang == 'es';
		});
		if (es) {
			this.es.is_active = es.is_active;
			this.es.default = es.default;
		}
	},

	watch: {
		settings: {},
	},
	components: {
		TourOverlay,
		KeyValueCard,
		VatDialog,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// riga a cui il tutorial aggancia il menu a tre puntini (la predefinita non ce l'ha)
		primaNonDefault() {
			return this.vats.findIndex(v => !v.default);
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		// la lista si salva sempre intera (POST profile/vat): ritorna true se il server l'ha accettata
		async salvaVats(lista) {
			this.setPreload(true);
			try {
				const { data } = await axios.post(`${this.getUrl}profile/vat`, lista, { headers: { Authorization: `Bearer ${this.getToken}` } });
				this.setSettings(data.data);
				// dal server tornano anche gli _id delle aliquote appena aggiunte
				this.vats = data.data && Array.isArray(data.data.vat) ? data.data.vat : lista;
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con  successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return true;
			} catch (err) {
				if (err.response) {
					let errors = err.response.data.error;
					if (errors) {
						if (_.isArray(errors)) {
							errors.forEach(value => {
								this.messages[value.param] = value.msg;
							});
						} else {
							err.message = errors;
						}
					}
					if (err.response.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				}
				this.snackbar.color = 'error';
				this.snackbar.text = err.message;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return false;
			} finally {
				this.setPreload(false);
			}
		},
		changeDefault(vat) {
			this.salvaVats(this.vats.map(cur => ({ ...cur, default: cur === vat })));
		},
		changeStatus() {
			this.salvaVats(this.vats);
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		async confirmDelete() {
			this.dialogconfirm = false;
			const item = this.daEliminare;
			this.daEliminare = null;
			if (item) await this.salvaVats(this.vats.filter(r => r !== item));
		},
		// arriva dal dialog gia' validato
		async addValue({ vat, is_active }) {
			const ok = await this.salvaVats([...this.vats, { is_active, vat, default: false }]);
			if (ok) this.dialogNuova = false;
		},
		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		saveSetting(item) {
			var payload;
			switch (item) {
				case 0:
					payload = this.mws;
					this.preload = true;

					break;
				case 1:
					payload = this.ebay;
					this.preload = true;

					break;
			}
			let url = 'profile/update';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);

					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(`${this.getUrl}${url}`);
		},
		extension(item) {
			var prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				var indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}

			/*this.selected.push(item)

                    if (!this.getOrders[item].hide) {
                        this.getOrders[item].hide = true;
                    } else  {
                        this.getOrders[item].hide = false;
                    }*/
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				var response = await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

	},
};
</script>

<style></style>

<style scoped>
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
